import {ERequestType, TRequestTableResponseWithPagination} from 'shared/types/requests';
import {IRpcDeleteResponse} from 'shared/types/rpc';
import {performRequest} from 'shared/utils';

import {AIS3_SCENARIO_SETTINGS_API_PREFIX} from './ais-notification-scenarios-settings-constants';
import {IAisNotificationScenariosSettingsServices, IAisNotificationScenariosSettingsTableDto} from './ais-notification-scenarios-settings-types';

export const fetchAisNotificationScenariosSettingsTable = (
    params: IFetchAisNotificationScenariosSettingsParams,
) => performRequest<TRequestTableResponseWithPagination<IAisNotificationScenariosSettingsTableDto>>({
    url: AIS3_SCENARIO_SETTINGS_API_PREFIX,
    method: ERequestType.GET,
    params,
});

export const fetchAisNotificationScenariosServices = () => (
    performRequest<IAisNotificationScenariosSettingsServices[]>({
        url: `${AIS3_SCENARIO_SETTINGS_API_PREFIX}/get-services`,
        method: ERequestType.GET,
    }));

export const deleteAisNotificationScenariosSettingsTableRowsRequest = async (
    {
        ids,
    }: IDeleteAisNotificationScenariosSettingsTableRowsParams,
) => performRequest<IRpcDeleteResponse>({
    url: `${AIS3_SCENARIO_SETTINGS_API_PREFIX}/rpc/delete-list`,
    method: ERequestType.DELETE,
    data: {ids},
});

export const postAisNotificationScenariosSetting = async (
    data: TPostAisNotificationScenariosSettingData,
) => performRequest<string>({
    url: AIS3_SCENARIO_SETTINGS_API_PREFIX,
    method: ERequestType.POST,
    data,
});

export const putAisNotificationScenariosSetting = async (
    data: TPutAisNotificationScenariosSettingData,
) => performRequest<string>({
    url: AIS3_SCENARIO_SETTINGS_API_PREFIX,
    method: ERequestType.PUT,
    data,
});

export interface IFetchAisNotificationScenariosSettingsParams {
  length?: number;
  paginationCurrent?: number;
  paginationPageSize?: number;
  search?: string | null;
  sorterField?: string;
  sorterOrder?: 'ascend' | 'descend';
  start?: number;
  taxPeriodId?: number;
  organizationId?: number;
}

export interface IDeleteAisNotificationScenariosSettingsTableRowsParams {
    ids: number[];
}

export type TPostAisNotificationScenariosSettingData = Partial<Pick<IAisNotificationScenariosSettingsTableDto,
'interactionScenarioId'
| 'notificationName'
| 'responseCodeId'
| 'recipientGroupsIds'
| 'recipientUsersIds'
| 'notificationMessage'
>>

export type TPutAisNotificationScenariosSettingData = {id: number}
& Partial<Pick<IAisNotificationScenariosSettingsTableDto,
'interactionScenarioId'
| 'notificationName'
| 'responseCodeId'
| 'recipientGroupsIds'
| 'recipientUsersIds'
| 'notificationMessage'
>>
